import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DropdownMenu = () => {
    const [isOpen, setIsOpen] = useState(false);
    var roleID =localStorage.getItem("roleID");
    var guid =localStorage.getItem("guid");

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    return (
        <li className="dropdown" onClick={toggleDropdown}>
            <span className="sd-link" style={{fontSize:14}}>
                Admin <span className="dropdown-icon mt-1" style={{fontSize:12,float:"right"}}>&#9660;</span>
            </span>
            {isOpen && (
                <ul className="dropdown-menu">
                                     <li><Link to="/Employer/JobRoles" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Job Roles</Link></li>           
                                     <li><Link to="/Employer/ListofClients" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Client Directory</Link></li>           
                                     {/* <li><Link to="/Employer/ListofStaffingContacts" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Sub Vendors</Link></li>            */}

                 <li><Link to="/Employer/ListofUsers" style={{ color: "#fff", backgroundColor: "#00a7ac" }} className="sd-link">Logins</Link></li>           
                <li>
                        
                            <Link
                                to="/Employer/Cleanup"
                                className="sd-link"
                                style={{ color: "#fff", backgroundColor: "#00a7ac" }}
                                onClick={toggleDropdown}
                            >
                               Mails Cleanup 
                            </Link>
                        </li>
                           <li>
                                <Link
                                    to="/Employer/DiceCredits"
                                    className="sd-link"
                                    style={{ color: "#fff", backgroundColor: "#00a7ac" }}
                                    onClick={toggleDropdown}
                                >
                                    Dice Credits
                                </Link>
                            </li>
                   <li>
                            <Link
                                to="/Employer/ListOfLeads"
                                className="sd-link"
                                style={{ color: "#fff", backgroundColor: "#00a7ac" }}
                                onClick={toggleDropdown}
                            >
                                Leads
                            </Link>
                        </li>
                  
                         
                            {/* <li>
                                <Link
                                    to="/Employer/ListOfMovedVideos"
                                    className="sd-link"
                                    style={{ color: "#fff", backgroundColor: "#00a7ac" }}
                                    onClick={toggleDropdown}
                                >
                                    Moved Videos
                                </Link>
                            </li> */}
                            {/* <li className='mb-5'>
                                <Link
                                    to="/Employer/ListOfDeletedVideos"
                                    className="sd-link"
                                    style={{ color: "#fff", backgroundColor: "#00a7ac" }}
                                    onClick={toggleDropdown}
                                >
                                    Deleted Videos
                                </Link>
                            </li> */}
                    
                </ul>
            )}
        </li>
    );
};

export default DropdownMenu;
